import { ModeToggle } from '@/components/mode-toggle'
import { Gift, Github } from 'lucide-react'
import React from 'react'
import {Link} from 'react-router-dom'
import { NavLink } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Highlighter } from '@/components/ui/highlighter';


export default function Navigationbar() {
  return (
    <nav className="w-full" aria-label="Global">
        <div className='flex flex-col items-end'>

            {/* <NavLink
              exact
              className='flex-none text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out text-sm'
              to="/"
              activeClassName="active" 
              >Index
            </NavLink>
            <NavLink
              exact
              className='flex-none text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out text-sm'
              to="/craft"
              activeClassName="active" 
              >
                Craft
            </NavLink>
            <NavLink
              exact
              className='flex-none text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out text-sm'
              to="/contact"
              activeClassName="active" 
              >
                Contact
            </NavLink> */}
            <NavLink
              exact
              className='flex-none text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out text-sm px-2'
              to="/resume"
              activeClassName="active" 
              target='_blank'
              >
                Resume
            </NavLink>
            <DropdownMenu>
              <DropdownMenuTrigger>
                <Highlighter action="underline" color="#FF9800" delay={2000}>
                  <p className='text-black dark:text-white text-sm pt-2 cursor-pointer'>Microstock</p>
                </Highlighter>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-48 rounded-xl" align="start">
                <DropdownMenuGroup>
                  <Link to='https://stock.adobe.com/contributor/213456850/dinivannendragunawan' target='_blank'>
                    <DropdownMenuItem className='cursor-pointer'>
                      Adobe Contributor
                    </DropdownMenuItem>
                  </Link>
                  <Link to='https://www.shutterstock.com/g/dinivannendra' target='_blank'>
                    <DropdownMenuItem className='cursor-pointer'>
                      Shutterstock Contributor
                    </DropdownMenuItem>
                  </Link>
                </DropdownMenuGroup>
              </DropdownMenuContent>
            </DropdownMenu>
            {/* <NavLink
              exact
              className='flex-none text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out text-sm'
              to="/family"
              activeClassName="active" 
              >
                Family
            </NavLink> */}
        </div>
    </nav>
  )
}